export default "__VITE_ASSET__Bdb$9RRf__"